module.exports = __webpack_public_path__ + "img/caodi3.ff1050ef.png";